module.exports = __webpack_public_path__ + "static/media/1010689.e914e25a.jpg";